(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6504],{

/***/ 56626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clanky/[slug]",
      function () {
        return __webpack_require__(3312);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41246);
/* harmony import */ var _components_NavBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55270);
/* harmony import */ var _components_domain_post_PostView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49761);
/* harmony import */ var _components_domain_post_blog_clanky_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59982);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26221);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80371);








var SinglePostPage = function(param) {
    var post = param.post;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Head__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "".concat(post.title || "Čl\xe1nok", " | Street of Code"),
                description: ((ref = post.excerpt) === null || ref === void 0 ? void 0 : ref.replace("<p>", "").replace("</p>", "")) || "Toto je čl\xe1nok, ktor\xfd nem\xe1 poriadny popis. Ups, pard\xf3n, dopln\xedme.",
                url: (0,_routes__WEBPACK_IMPORTED_MODULE_5__/* .prefixWithHost */ .O)(_routes__WEBPACK_IMPORTED_MODULE_5__/* .routes.clanky.slug */ ._.clanky.slug(post.slug || "")),
                imageUrl: ((ref1 = post.featuredImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.node) === null || ref2 === void 0 ? void 0 : ref2.sourceUrl) || _components_domain_post_blog_clanky_constants__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_BLOG_IMAGE_PLACEHOLDER_URL */ .xf
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_NavBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_domain_post_PostView__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    post: post
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SinglePostPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,7138,4786,7141,7635,5270,1666,9761,9774,2888,179], function() { return __webpack_exec__(56626); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);